<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div style="margin-left: 10px; margin-right: 10px">
        <div
          class="pt-8"
          style="
            font-size: 20px;
            margin-left: 1rem;
            margin-right: 1rem;
            color: #444444;
          "
        >
          {{ $t("message.ManagePreRegister") }}
        </div>
        <v-card-text>
          <div>
            <v-card
              elevation="10"
              style="padding: 2%; margin-top: 2%; margin-bottom: 2%"
            >
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="4" class="pt-5">
                  <v-text-field
                    :label="$t('message.Search')"
                    append-icon="mdi-database-search-outline"
                    @keyup.enter="getDataTransactionPreRegister"
                    clearable
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  lg="4"
                  class="pt-5"
                  align="center"
                >
                  <v-btn
                    height="40"
                    width="150"
                    color="green"
                    class="white--text"
                    @click="CreatePreRegister()"
                  >
                    {{ $t("message.Create") }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-data-table
                    :headers="headers"
                    :items="ListData"
                    hide-default-footer
                    style="color: #332f2fde"
                    :items-per-page="itemsPerPage"
                    :mobile-breakpoint="0"
                    :page.sync="page"
                    single-line
                    hide-details
                  >
                    <template v-slot:item="{ item, index }">
                      <tr>
                        <td class="header-table-css">
                          {{ no_run + (index + 1) }}
                        </td>
                        <td class="header-table-css">
                          {{ ChangeFormatDate(item.startDateTime) }}
                        </td>
                        <td class="header-table-css">
                          {{ ChangeFormatDate(item.endDateTime) }}
                        </td>
                        <td class="header-table-css">
                          {{ item.guestInviteName }}
                        </td>
                        <td class="header-table-css">
                          {{ item.inviteLocationName }}
                        </td>
                        <td class="header-table-css">
                          {{ item.inviteTenantName }}
                        </td>
                        <td class="header-table-css">
                          {{ ChangeFormatDate(item.createTime) }}
                        </td>
                        <td
                          style="
                            padding-bottom: 5px;
                            display: flex;
                            flex-direction: column-reverse;
                            align-items: center;
                          "
                        >
                          <v-btn
                            :color="GetColor(item.active)"
                            rounded
                            class="text-capitalize"
                            depressed
                            style="width: 150px"
                          >
                            <span
                              :style="{ color: GetColorText(item.active) }"
                              >{{ ConvertNameStatus(item.active) }}</span>
                          </v-btn>
                        </td>
                        <td style="text-align: center">
                          <template>
                            <v-btn
                              :disabled="!item.active"
                              class="mx-2"
                              fab
                              dark
                              small
                              color="#2196F3"
                              @click="ShowQRPreRegister(item.inviteID)"
                            >
                              <v-icon dark>mdi-qrcode</v-icon>
                            </v-btn>
                          </template>
                          <template>
                            <v-btn
                              class="mx-2"
                              fab
                              dark
                              small
                              color="orange"
                              @click="ViewDataPreRegisterDialog(item.inviteID)"
                            >
                              <v-icon dark>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <template>
                            <v-btn
                              :disabled="!item.active"
                              class="mx-2"
                              fab
                              dark
                              small
                              color="red"
                              @click="cancelPreRegisterByUid(item.inviteID)"
                            >
                              <v-icon dark>mdi-cancel</v-icon>
                            </v-btn>
                          </template>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row class="mt-5">
                <v-col cols="12" md="4"></v-col>
                <v-col cols="12" md="3">
                  <v-pagination
                    v-model="page"
                    :total-visible="20"
                    :length="pageCount"
                    @input="ChangePage(page)"
                  ></v-pagination>
                </v-col>
                <v-col cols="12" md="3"></v-col>
                <v-col cols="12" md="2">
                  <v-autocomplete
                    dense
                    solo
                    v-model="itemsPerPage"
                    @input="ChangePerPage(itemsPerPage)"
                    label="10/page"
                    :items="items"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="PreRegisterDataDialog" max-width="760px" persistent>
      <v-card class="rounded-xl">
        <v-card-title
          class="py-4 d-flex align-center"
          style="background-color: #1a1a1a; color: white"
        >
          <v-icon class="mr-3">mdi-account-eye-outline</v-icon>
          <span class="text-h6 font-weight-bold">{{ $t("message.ViewPreRegister") }}</span>
        </v-card-title>
        <v-card-text class="pt-6 pb-0">
          <v-container fluid>
            <div class="section-title">
              <v-icon size="20" class="mr-1">mdi-account-circle-outline</v-icon>
              {{ $t("message.GuestInformation") }}
            </div>

            <v-row class="mt-2">
              <v-col cols="12" md="4" class="label-col">
                <p class="label-text">{{ $t("message.InviteNo") }}</p>
                <p class="label-text">{{ $t("message.InviteName") }}</p>
                <p class="label-text">{{ $t("message.Location") }}</p>
                <p class="label-text">{{ $t("message.Tenant") }}</p>
              </v-col>

              <v-col cols="12" md="8">
                <p class="value-text">{{ ViewData.inviteID }}</p>
                <p class="value-text">{{ ViewData.guestInviteName }}</p>
                <p class="value-text">{{ ViewData.inviteLocationName }}</p>
                <p class="value-text">{{ ViewData.inviteTenantName }}</p>
              </v-col>
            </v-row>
            <v-divider class="my-6"></v-divider>
            <div class="section-title">
              <v-icon size="20" class="mr-1">mdi-calendar-month-outline</v-icon>
              {{ $t("message.VisitDuration") }}
            </div>
            <v-row class="mt-2">
              <v-col cols="12" md="4" class="label-col">
                <p class="label-text">{{ $t("message.StartDate") }}</p>
                <p class="label-text">{{ $t("message.EndDate") }}</p>
              </v-col>
              <v-col cols="12" md="8">
                <p class="value-text">
                  {{ ChangeFormatDate(ViewData.startDateTime) }}
                </p>
                <p class="value-text">
                  {{ ChangeFormatDate(ViewData.endDateTime) }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="px-6 pb-6 justify-end">
          <v-btn
            variant="outlined"
            color="grey"
            width="120"
            append-icon="mdi-close-circle-outline"
            class="px-6 white--text"
            @click="PreRegisterDataDialog = false"
          >
            {{ $t("message.Close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ManagePreRegister",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      no_run: 0,

      ListData: [],
      PreRegisterDataDialog: false,
      ViewData: [],

      VisitorName: "",
      Email: "",
      PhoneNumber: "",
      TowerName: "",
      FloorName: "",
      Start_Date: "",
      End_Date: "",
      CreateTime: "",
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: this.$t("message.StartDate"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.EndDate"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.GuestInviteName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.InviteLocationName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.InviteTenantName"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.CreateTime"),
          align: "left",
          sortable: false,
        },
        {
          text: this.$t("message.Status"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("message.Action"),
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    self.getDataTransactionPreRegister();
  },

  methods: {
    getDataTransactionPreRegister() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: self.page,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}PreRegister/getDataTransactionPreRegister`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perPage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
      };
      axios
        .post(`${self.url}PreRegister/getDataTransactionPreRegister`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perPage: value,
      };
      axios
        .post(`${self.url}PreRegister/getDataTransactionPreRegister`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ViewDataPreRegisterDialog(data) {
      let self = this;
      self.ViewDataPreRegister(data);
    },

    CreatePreRegister() {
      let self = this;
      self.$router.push("/PreRegister");
    },

    ViewDataPreRegister(data) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        invite_uid: data,
      };
      axios
        .post(`${self.url}PreRegister/getDataTransactionPreRegisterByUid`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.BindingDataPreRegister(response.data.data);
          }
        })
        .catch(function (error) {
          Swal.fire({
            icon: "error",
            title: "Error...",
            width: 900,
            text: error.response.data.message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    BindingDataPreRegister(data) {
      let self = this;
      self.ViewData = data;
      self.PreRegisterDataDialog = true;
    },

    cancelPreRegisterByUid(id) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        invite_uid: id,
      };
      Swal.fire({
        title: this.$t("message.Reject"),
        text: this.$t("message.WantToReject"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post(`${self.url}PreRegister/cancelPreRegisterByUid`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                self.getDataTransactionPreRegister();
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch(function (error) {
              Swal.fire({
                icon: "error",
                title: "Error...",
                width: 900,
                text: error.response.data.message,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
        else {
          self.LoadingDialog = false;
        }
      });
    },

    ShowQRPreRegister(data) {
      window.open("QRPreRegister/" + data, "_blank");
    },

    GetColor(value) {
      if (value == "Active") {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == "Active") {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },

    ConvertNameStatus(Name) {
      if (Name != "") {
        if (Name == "Active") {
          return this.$t("message.Active");
        } else if (Name == "Expired") {
          return this.$t("message.Expired");
        } else {
          return this.$t("message.Rejected");
        }
      }
      return "";
    },
  },
};
</script>
  <style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.label-col {
  text-align: right;
}

@media (max-width: 960px) {
  .label-col {
    text-align: left;
  }
}

.label-text {
  font-size: 18px;
  font-weight: 500;
  color: #555;
  margin: 8px 0;
}

.value-text {
  font-size: 18px;
  font-weight: 600;
  color: #111;
  margin: 8px 0;
}

.section-title {
  font-size: 20px;
  font-weight: 700;
  color: #333;
  display: flex;
  align-items: center;
}
</style>
  